import { Link } from '@app/router';
import { chakra } from '@stockx/ui';

export const NavHeader = chakra('div', {
  baseStyle: {
    background: 'neutral.white',
    display: 'flex',
    padding: 4,
    height: '52px',
    alignItems: 'center',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'neutral.300',
  },
});

export const NavHeaderImgWrapper = chakra(Link, {
  baseStyle: {
    paddingRight: 5,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
});
